import styled from 'styled-components';

export const StepBarRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const StepColumn = styled.div<{ $clickable?: boolean }>`
  width: 100%;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  user-select: none;
`;

/**
 * Three states in one bar: the step you are on is solid, the ones behind you
 * are the same red faded out, and the ones ahead are a grey rule. Fading the
 * done steps rather than colouring them differently is what makes the bar
 * read as progress instead of as four unrelated tabs.
 */
export const StepTrack = styled.div<{ $active: boolean; $done: boolean }>`
  height: 4px;
  border-radius: 2px;
  margin-bottom: 6px;
  background: ${({ theme, $active, $done }) => {
    if ($active) return theme.primary;
    if ($done) return `${theme.primary}${theme.transparency.t40}`;
    return theme.mediumGray;
  }};
`;

export const StepLabel = styled.p<{ $active: boolean }>`
  margin: 0;
  font-size: 12px;
  color: ${({ theme, $active }) => ($active ? theme.primary : theme.lightGray)};
`;
